/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_Rule_SupportInputs */



/**
* | output |
* | --- |
* | "Wundo support" |
*
* @param {Meetings_Exception_Rule_SupportInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_rule_support = /** @type {((inputs?: Meetings_Exception_Rule_SupportInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_Rule_SupportInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo-ondersteuning")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accompagnement Wundo")
	return /** @type {LocalizedString} */ ("Wundo support")
});